var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 2.3.6")), /*#__PURE__*/React.createElement("g", {
    id: "icon-1",
    transform: "translate(512 512) scale(8.24 8.24)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 6.29 23.06 H 17.8 a 1 1 0 0 0 1 -1 V 10.71 a 1 1 0 0 0 -2 0 V 21.06 H 6.29 a 1 1 0 1 0 0 2 Z",
    fill: "currentColor",
    transform: "translate(-37.955 -33.615) translate(-12.045000000000002, -16.384999999999998) "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 23.47 23.06 H 61.84 a 1 1 0 0 0 1 -1 V 3.54 a 1 1 0 0 0 -2 0 V 21.06 H 24.47 V 7.21 a 1 1 0 0 0 -2 0 V 22.06 A 1 1 0 0 0 23.47 23.06 Z",
    fill: "currentColor",
    transform: "translate(-7.345 -37.2) translate(-42.655, -12.8) "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 67.35 23.06 h 20 a 1 1 0 0 0 0 -2 h -19 V 4.54 h 19 a 1 1 0 0 0 0 -2 h -20 a 1 1 0 0 0 -1 1 V 22.06 A 1 1 0 0 0 67.35 23.06 Z",
    fill: "currentColor",
    transform: "translate(27.35 -37.2) translate(-77.35, -12.8) "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 8 43.91 a 1 1 0 0 0 0 2 H 40.49 a 1 1 0 0 0 1 -1 V 27.06 a 1 1 0 0 0 -1 -1 H 10.79 a 1 1 0 1 0 0 2 h 28.7 V 43.91 Z",
    fill: "currentColor",
    transform: "translate(-25.755 -14.015) translate(-24.245, -35.985) "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 84 44.91 V 27.06 a 1 1 0 0 0 -1 -1 H 45.5 a 1 1 0 0 0 -1 1 V 44.91 a 1 1 0 0 0 1 1 H 83 A 1 1 0 0 0 84 44.91 Z m -2 -1 H 46.5 V 28.06 H 82 Z",
    fill: "currentColor",
    transform: "translate(14.25 -14.015) translate(-64.25, -35.985) "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 93.71 43.91 H 88.37 V 28.06 h 5.34 a 1 1 0 0 0 0 -2 H 87.37 a 1 1 0 0 0 -1 1 V 44.91 a 1 1 0 0 0 1 1 h 6.34 a 1 1 0 1 0 0 -2 Z",
    fill: "currentColor",
    transform: "translate(40.54 -14.015) translate(-90.54, -35.985) "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 93.71 52.42 a 1 1 0 0 0 0 -2 H 67.35 a 1 1 0 0 0 -1 1 V 71.27 a 1 1 0 0 0 1 1 H 93.71 a 1 1 0 0 0 0 -2 H 68.35 V 52.42 Z",
    fill: "currentColor",
    transform: "translate(30.53 11.345) translate(-80.53, -61.345) "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 23.47 72.27 H 61.84 a 1 1 0 0 0 1 -1 V 51.42 a 1 1 0 0 0 -1 -1 H 23.47 a 1 1 0 0 0 -1 1 V 71.27 A 1 1 0 0 0 23.47 72.27 Z m 1 -19.85 H 60.84 V 70.27 H 24.47 Z",
    fill: "currentColor",
    transform: "translate(-7.345 11.345) translate(-42.655, -61.345) "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.29 70.27 a 1 1 0 0 0 0 2 H 17.8 a 1 1 0 0 0 1 -1 V 51.42 a 1 1 0 0 0 -1 -1 H 6.29 a 1 1 0 1 0 0 2 H 16.8 V 70.27 Z",
    fill: "currentColor",
    transform: "translate(-37.955 11.345) translate(-12.045000000000002, -61.345) "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 39.49 75.61 H 6.29 a 1 1 0 0 0 0 2 h 32.2 V 95.46 H 6.29 a 1 1 0 0 0 0 2 h 33.2 a 1 1 0 0 0 1 -1 V 76.61 A 1 1 0 0 0 39.49 75.61 Z",
    fill: "currentColor",
    transform: "translate(-27.11 36.535) translate(-22.89, -86.535) "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 83.7 75.61 H 46.16 a 1 1 0 0 0 -1 1 V 96.46 a 1 1 0 0 0 1 1 H 83.7 a 1 1 0 0 0 1 -1 V 76.61 A 1 1 0 0 0 83.7 75.61 Z m -1 19.85 H 47.16 V 77.61 H 82.7 Z",
    fill: "currentColor",
    transform: "translate(14.93 36.535) translate(-64.93, -86.535) "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 93.71 75.61 H 88.54 a 1 1 0 0 0 -1 1 V 96.46 a 1 1 0 0 0 1 1 h 3.33 a 1 1 0 0 0 0 -2 H 89.54 V 77.61 h 4.17 a 1 1 0 0 0 0 -2 Z",
    fill: "currentColor",
    transform: "translate(41.125 36.535) translate(-91.125, -86.535) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b1f99582e5c815e57b1c3f5bd83d5c6a.svg";
export { ForwardRef as ReactComponent };